import {useEffect} from 'react'
import {WalletConfigModalHeader} from './WalletConfigModalHeader'
import {WalletConfigModalForm} from './WalletConfigModalForm'

export const WalletConfigModal = ({ getUser, user, setOpenWalletConfigModal }) => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          <div className='modal-content'>
            <WalletConfigModalHeader setOpenWalletConfigModal={setOpenWalletConfigModal} />
            <div className={`modal-body scroll-y mx-5`}>
              <WalletConfigModalForm getUser={getUser} user={user} setOpenWalletConfigModal={setOpenWalletConfigModal} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'/>
    </>
  )
}
